var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMiddleSpeed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 21,
    viewBox: "0 0 37 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6573 0.759089C18.166 0.413637 18.834 0.413637 19.3427 0.759089L35.8427 11.9642C36.5281 12.4296 36.7063 13.3625 36.2409 14.0478C35.7755 14.7331 34.8427 14.9114 34.1573 14.446L18.5 3.81318L2.84272 14.446C2.15739 14.9114 1.22452 14.7331 0.759115 14.0478C0.293705 13.3625 0.471991 12.4296 1.15733 11.9642L17.6573 0.759089Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6573 6.75909C18.166 6.41364 18.834 6.41364 19.3427 6.75909L35.8427 17.9642C36.5281 18.4296 36.7063 19.3625 36.2409 20.0478C35.7755 20.7331 34.8427 20.9114 34.1573 20.446L18.5 9.81318L2.84272 20.446C2.15739 20.9114 1.22452 20.7331 0.759115 20.0478C0.293705 19.3625 0.471991 18.4296 1.15733 17.9642L17.6573 6.75909Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiddleSpeed);
export default __webpack_public_path__ + "static/media/middle-speed.b34036b174801032bd1690000fe94393.svg";
export { ForwardRef as ReactComponent };